export const SEARCH_QUERY_MIN_CHARS = 3 as const;
